export default "__VITE_ASSET__965195aa__"